import classNames from 'classnames';
import { formatDate } from 'date-fns';

import { api } from '../api';
import { PaymentMethod, Price, SubscriptionResponse } from '../types';

import { Badge } from '../../ui/components/Badge';

const initialCapital = (str: string) => `${str[0].toLocaleUpperCase()}${str.slice(1)}`;

type Props = {
  subscription: SubscriptionResponse
}

export const SubscriptionInfo = ({ subscription: { payment_method, price, subscription } }: Props) => (
  <div className='my-4 flex flex-col justify-center'>
    <StateBadge state={subscription.cancel_at_period_end ? 'cancelled' : subscription.status} />
    {
      !subscription.cancel_at_period_end && (
        <Renewal
          paymentMethod={payment_method}
          periodEnd={subscription.current_period_end}
          price={price}
        />
      )
    }
    {
      subscription.cancel_at_period_end && (
        <Cancelling periodEnd={subscription.current_period_end} />
      )
    }
    {
      subscription.status === 'active' && !subscription.cancel_at && (
        <CancelSubscription />
      )
    }
  </div>
);

const StateBadge = ({ state }: { state: string }) => {
  const classes = classNames(
    '!text-lg self-center',
    {
      'ring-green-500 bg-green-100 text-green-700': state === 'active',
      'ring-blue-500 bg-blue-100 text-blue-700': state === 'trialing',
      'ring-neutral-500 bg-neutral-100 text-neutral-700': state === 'cancelled'
    }
  );

  return (
    <Badge className={classes}>
      ● { initialCapital(state) }
    </Badge>
  );
};

type RenewalProp = {
  paymentMethod?: PaymentMethod,
  periodEnd: string,
  price: Price
}

const Renewal = ({ paymentMethod, periodEnd, price }: RenewalProp) => (
  <>
    <p className='my-4'>
      Your subscription will <b>automatically renew</b> after the current period
      ends on { ' ' }
      <b>{ formatDate(periodEnd, "do MMMM yyyy") }</b>.
    </p>
    {
      paymentMethod && (
        <p>
          Your { initialCapital(paymentMethod.card.brand) } ending { ' ' }
          <span className='font-mono bg-neutral-50 p-1'>
            { paymentMethod.card.last4 }
          </span>{ ' ' }
          will be charged { (price.unit_amount / 100).toFixed(2) } { price.currency.toLocaleUpperCase() }.
        </p>
      )
    }
  </>
);

type CancellingProps = {
  periodEnd: string
}

const Cancelling = ({ periodEnd }: CancellingProps) => (
  <>
    <p className='my-4'>
      Your subscription will end on { formatDate(periodEnd, "do MMMM yyyy") },
      after which you will no longer have access to the benefits of JustWords
      Premium. You will only be able to store a limited number of items in your
      Library and they will no longer sync across devices.
    </p>
    <p className='my-4'>
      You can resubscribe after this date to regain these benefits.
    </p>
  </>
);

// 'Are you sure you want to cancel your subscription? ' +
// 'At the end of the current subscription period, you will lose access to the benefits ' +
// 'of JustWords Premium, you will only be able to store a limited number of items ' +
// 'in your library and it will no longer sync across devices.';

const CancelSubscription = () => {

  const [cancelSubscription] = api.useCancelSubscriptionMutation();

  return (
    <a
      className='inline-block text-sm my-4 text-neutral-500 hover:text-neutral-400 cursor-pointer self-start'
      onClick={() => cancelSubscription()}
    >
      Cancel subscription
    </a>
  );
};
